export const userConstants = {      
    LOGOUT: 'USERS_LOGOUT',
    SET_CURRENT_CUSTOMER: 'USET_CURRENT_CUSTOMER',        
    CHECK_SMS:'CHECK_SMS',
    REQUEST_CODE:'REQUEST_CODE',
    SET_SERVICETYPE:'SET_SERVICETYPE',
    SET_CURRENT_USER: 'SET_CURRENT_USER', 
    
};